module.exports = __webpack_public_path__ + "static/media/20_potolok_12.45_0.ba1ef0a4.png";